module.exports = "/_next/static/images/energy-storage-systems-b7d55371b034a992bb53db86b0808a43.webp";